export default "__VITE_ASSET__CGyBRxvC__"